import React from "react";
import { Switch, Route } from "react-router-dom";
import Trackingstatusdashboard from "./Index";

export default () => (
    <Switch>
        <Route exact path="/truckstatusdashboard" component={Trackingstatusdashboard} />
    </Switch>
);
